import { Result } from '@restless/sanitizers';
import { BigNumber } from 'ethers';
export var asBigNumber = function (value, path) {
    try {
        if (BigNumber.isBigNumber(value)) {
            return Result.ok(value);
        }
        else if (typeof value === 'string' || typeof value === 'number') {
            return Result.ok(BigNumber.from(value));
        }
    }
    catch (_a) { } // tslint:disable-line
    return Result.error([{ path: path, expected: 'big number' }]);
};
